import React, { useState } from 'react';
import Dots from '../../components/Dots';
import SkillBlock from '../../components/SkillBlock';
import skills from '../../consts/skills';

const FUNNY_TITLE = "stack overflow search terms";

const Skills = ({ t, skillsData }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <section className="skills">
      <h2
        className={`h2 ${hovered ? 'h2--hovered' : ''}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {hovered ? FUNNY_TITLE : t.title}
      </h2>
      <div className="skills__content">
        <div className="skills__illustrations illustrations">
          <img src="/images/logo-outline.svg" alt="" className="illustrations__logo" />
          <Dots />
          <Dots />
        </div>
        <div className="skills__list">
          {Object.keys(skills)
            .filter(id => id !== "tool")
            .map(id => (
              <SkillBlock
                key={id}
                title={skillsData[id]}
                category={id}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
